import React from 'react';

import { ThemeText as AchievableThemeText } from '@achievable-me/ux';

const ThemeText = (props) => {
  const { bold, children, className, noWrap, theme } = props;

  return (
    <AchievableThemeText bold={bold} className={className} noWrap={noWrap} theme={theme}>
      {children}
    </AchievableThemeText>
  );
};

export default ThemeText;
